'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("itTreeDefaultConfig", function (itDefaultConfig) {
  return _.extend(angular.copy(itDefaultConfig), {
    type: "tree",
    initialDepth: 0,
    // the initial depth level to be opened, can either be boolean (true -> all , false -> 0) a number or a function returning a number.
    // config
    idAttribute: "id",
    labelAttribute: "id",
    childrenAttribute: "children",
    // spacers
    showSpacers: true,
    // false to use only blank space as spacer.
    spacerCrossClass: "spacer-cross",
    spacerCornerClass: "spacer-corner",
    spacerLineClass: "spacer-line",
    spacerNoneClass: "spacer-none",
    // templates
    nodeCellTemplate: '<it-tree-table-node-cell></it-tree-table-node-cell>',
    mainCellTemplate: '<td class="it-tree-cell"></td>',
    mainCellContentTemplate: '<div></div>',
    spacerTemplate: '<it-tree-table-spacer></it-tree-table-spacer>',
    togglerTemplate: '<it-tree-table-row-toggler></it-tree-table-row-toggler>',
    // directives
    rowDirective: "it-row it-tree-table-row",
    /**
     * si true, alors pas de lignes tracées au niveau racine
     */
    noRootLines: false
  });
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/infiniTable/tree/itTreeTableDefaultConfig.js
// module id = 2820
// module chunks = 13